module.exports = __webpack_public_path__ + "static/media/PATS_6-1018w.2de0e815.webp";